module.exports = __webpack_public_path__ + "media/components/assets/img/bg/circle-f0a82c95a121ac2994ebac7541874734.svg";